export default "__VITE_ASSET__C8vqk9Uj__"